import { IconFileTreeOutline18 as TreeIcon } from "nucleo-ui-outline-18"

import type {} from "@productlane/lib/src/tiptap/extensions/mintlify/tree"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const treeCommand: SlashCommandDefinition = {
	key: "file-tree",
	title: "File tree",
	icon: <TreeIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertTree().run()
	},
	group: "blocks",
	aliases: ["tree", "file tree", "folder", "folders", "directory", "files"],
}
